import { Landmark, Users, Scale, GitBranch, Layers, ShieldCheck, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";
import Reveal from "@/components/Reveal";
import { serviceOrder } from "@/data/servicePages";

const icons = [Landmark, Users, Scale, GitBranch, Layers, ShieldCheck];

export default function Services() {
  const { t } = useLanguage();
  return (
    <section id="services" data-testid="services-section" className="bg-white py-24 md:py-32">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16">
          <Reveal className="md:col-span-7">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-700 mb-4">{t.services.overline}</p>
            <h2 className="font-outfit text-3xl md:text-4xl lg:text-5xl font-medium tracking-tight text-slate-950">
              {t.services.title1}<br />{t.services.title2}
            </h2>
          </Reveal>
          <Reveal className="md:col-span-5 flex items-end" delay={0.15}>
            <p className="text-base text-slate-600 leading-relaxed">{t.services.desc}</p>
          </Reveal>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-s border-slate-200">
          {t.services.items.map((s, i) => {
            const Icon = icons[i];
            const slug = serviceOrder[i];
            return (
              <Reveal key={s.title} delay={i * 0.07}>
                <Link
                  to={`/${slug}`}
                  data-testid={`service-card-${i}`}
                  aria-label={`${s.title}, learn more`}
                  className="group relative flex flex-col border-b border-e border-slate-200 p-8 lg:p-10 h-full bg-white hover:bg-brand transition-colors duration-300"
                >
                  <ArrowUpRight className="absolute top-8 end-8 lg:top-10 lg:end-10 w-5 h-5 text-slate-300 group-hover:text-white group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
                  <Icon className="w-7 h-7 text-brand-700 group-hover:text-white mb-6 transition-all duration-300 group-hover:-translate-y-1" strokeWidth={1.5} />
                  <h3 className="font-outfit text-xl font-medium text-slate-950 group-hover:text-white mb-3 pe-8 transition-colors">{s.title}</h3>
                  <p className="text-sm text-slate-600 group-hover:text-white/80 leading-relaxed transition-colors">{s.desc}</p>
                  <span className="mt-6 inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-[0.2em] text-brand-700 group-hover:text-white opacity-0 group-hover:opacity-100 transition-all">
                    Learn more
                  </span>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
